(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ebike-dropdowns"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatMoney(cents) {
      var amount = Math.abs(cents || 0) / 100;
      return '$' + amount.toFixed(2);
    }

    function updateDiffs(group, basePrice) {
      group.querySelectorAll('.js-diff-price').forEach(function (priceEl) {
        var optionWrap = priceEl.closest('.ebike-dropdowns__option');
        var option = optionWrap ? optionWrap.querySelector('.js-ebike-option') : null;
        if (!option) return;

        var optionPrice = option.dataset.currentProduct === 'true' ? basePrice : parseInt(option.dataset.price || '0', 10);
        var diff = optionPrice - basePrice;
        priceEl.textContent = (diff >= 0 ? '+' : '-') + formatMoney(diff);
      });
    }

    function parseMoney(text) {
      var value = parseFloat((text || '').replace(/[^0-9.]/g, ''));
      return isNaN(value) ? 0 : Math.round(value * 100);
    }

    function getVisibleProductPrice(group) {
      var scope = group.closest('.hdt-product__info-container') || document;
      var priceEl = scope.querySelector('.hdt-product__price .hdt-price__sale hdt-price .hdt-money, .hdt-product__price hdt-price .hdt-money');
      return priceEl ? parseMoney(priceEl.textContent) : 0;
    }

    function syncBasePrice(group, basePriceEl, options, basePrice) {
      if (!basePrice) return;

      basePriceEl.dataset.basePrice = basePrice;
      options.forEach(function (option) {
        if (option.dataset.currentProduct === 'true') {
          option.dataset.price = basePrice;
        }
      });
      updateDiffs(group, basePrice);
    }

    document.querySelectorAll('[data-ebike-dropdowns]').forEach(function (group) {
      var selectedValue = group.querySelector('.ebike-dropdowns__selected-value');
      var basePriceEl = group.querySelector('.js-current-base-price');
      var options = group.querySelectorAll('.js-ebike-option');

      if (!selectedValue || !basePriceEl || !options.length) return;

      syncBasePrice(group, basePriceEl, options, parseInt(basePriceEl.dataset.basePrice || '0', 10));

      options.forEach(function (option) {
        if (option.checked && option.dataset.label) {
          selectedValue.textContent = option.dataset.label;
        }

        option.addEventListener('change', function () {
          if (!option.checked) return;

          selectedValue.textContent = option.dataset.label || '';
          updateDiffs(group, parseInt(basePriceEl.dataset.basePrice || '0', 10));

          if (option.dataset.productUrl) {
            window.location.href = option.dataset.productUrl;
          }
        });
      });

      var productObserver = group.closest('hdt-product-observe');
      var formId = productObserver ? productObserver.getAttribute('form') : null;
      var productForm = formId ? document.getElementById(formId) : null;

      if (productForm) {
        productForm.addEventListener('product:updateNow', function (event) {
          var variant = event.detail ? event.detail.variant : null;
          if (!variant || !variant.price) return;

          syncBasePrice(group, basePriceEl, options, parseInt(variant.price, 10));
        });
      }

      var lastBasePrice = parseInt(basePriceEl.dataset.basePrice || '0', 10);
      setInterval(function () {
        var domPrice = getVisibleProductPrice(group);
        if (domPrice && domPrice !== lastBasePrice) {
          lastBasePrice = domPrice;
          syncBasePrice(group, basePriceEl, options, domPrice);
        }
      }, 300);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ebike_dropdowns"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatMoney(cents) {
      var amount = Math.abs(cents || 0) / 100;
      return '$' + amount.toFixed(2);
    }

    function updateDiffs(group, basePrice) {
      group.querySelectorAll('.js-diff-price').forEach(function (priceEl) {
        var optionWrap = priceEl.closest('.ebike-dropdowns__option');
        var option = optionWrap ? optionWrap.querySelector('.js-ebike-option') : null;
        if (!option) return;

        var optionPrice = option.dataset.currentProduct === 'true' ? basePrice : parseInt(option.dataset.price || '', 10);
        if (!optionPrice) return;
        var diff = optionPrice - basePrice;
        priceEl.textContent = (diff >= 0 ? '+' : '-') + formatMoney(diff);
      });
    }

    function parseMoney(text) {
      var value = parseFloat((text || '').replace(/[^0-9.]/g, ''));
      return isNaN(value) ? 0 : Math.round(value * 100);
    }

    function getVisibleProductPrice(group) {
      var scope = group.closest('.hdt-product__info-container') || document;
      var priceEl = scope.querySelector('.hdt-product__price .hdt-price__sale hdt-price .hdt-money, .hdt-product__price hdt-price .hdt-money');
      return priceEl ? parseMoney(priceEl.textContent) : 0;
    }

    function syncBasePrice(group, basePriceEl, options, basePrice) {
      if (!basePrice) return;

      basePriceEl.dataset.basePrice = basePrice;
      options.forEach(function (option) {
        if (option.dataset.currentProduct === 'true') {
          option.dataset.price = basePrice;
        } else if (option.dataset.targetProductPrice) {
          option.dataset.price = option.dataset.targetProductPrice;
        }
      });
      updateDiffs(group, basePrice);
    }

    function normalizePath(url) {
      if (!url) return '';

      var anchor = document.createElement('a');
      anchor.href = url;
      return anchor.pathname.replace(/\/$/, '');
    }

    function syncCurrentOptionFromUrl(options) {
      var currentPath = normalizePath(window.location.pathname);
      var matchedOption = null;

      options.forEach(function (option) {
        var optionPath = normalizePath(option.dataset.productUrl);
        if (optionPath && optionPath === currentPath) {
          matchedOption = option;
        }
      });

      if (!matchedOption) return null;

      options.forEach(function (option) {
        var isCurrent = option === matchedOption;
        option.dataset.currentProduct = isCurrent ? 'true' : 'false';
        option.checked = isCurrent;
      });

      return matchedOption;
    }

    document.querySelectorAll('[data-ebike-dropdowns]').forEach(function (group) {
      var selectedValue = group.querySelector('.ebike-dropdowns__selected-value');
      var basePriceEl = group.querySelector('.js-current-base-price');
      var options = group.querySelectorAll('.js-ebike-option');

      if (!selectedValue || !basePriceEl || !options.length) return;

      var currentOption = syncCurrentOptionFromUrl(options);
      if (currentOption && currentOption.dataset.label) {
        selectedValue.textContent = currentOption.dataset.label;
      }

      var initialBasePrice = getVisibleProductPrice(group)
        || (currentOption ? parseInt(currentOption.dataset.targetProductPrice || '', 10) : 0)
        || parseInt(basePriceEl.dataset.basePrice || '0', 10);

      syncBasePrice(group, basePriceEl, options, initialBasePrice);

      options.forEach(function (option) {
        var label = option.nextElementSibling;

        if (option.checked && option.dataset.label) {
          selectedValue.textContent = option.dataset.label;
        }

        if (label) {
          label.addEventListener('click', function (event) {
            if (option.dataset.currentProduct === 'true') return;

            event.preventDefault();
            selectedValue.textContent = option.dataset.label || '';
            updateDiffs(group, parseInt(basePriceEl.dataset.basePrice || '0', 10));

            if (option.dataset.productUrl) {
              window.location.href = option.dataset.productUrl;
            }
          });
        }

        option.addEventListener('change', function () {
          if (!option.checked) return;

          selectedValue.textContent = option.dataset.label || '';
          updateDiffs(group, parseInt(basePriceEl.dataset.basePrice || '0', 10));

          if (option.dataset.currentProduct !== 'true' && option.dataset.productUrl) {
            window.location.href = option.dataset.productUrl;
          }
        });
      });

      var productObserver = group.closest('hdt-product-observe');
      var formId = productObserver ? productObserver.getAttribute('form') : null;
      var productForm = formId ? document.getElementById(formId) : null;

      if (productForm) {
        productForm.addEventListener('product:updateNow', function (event) {
          var variant = event.detail ? event.detail.variant : null;
          if (!variant || !variant.price) return;

          syncBasePrice(group, basePriceEl, options, parseInt(variant.price, 10));
        });
      }

      var lastBasePrice = parseInt(basePriceEl.dataset.basePrice || '0', 10);
      setInterval(function () {
        var domPrice = getVisibleProductPrice(group);
        if (domPrice && domPrice !== lastBasePrice) {
          lastBasePrice = domPrice;
          syncBasePrice(group, basePriceEl, options, domPrice);
        }
      }, 300);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
